import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AdminCrudPage } from '../../pages/ajustes/admin-crud/admin-crud.page';

@Component({
  selector: 'app-componentes-genericos',
  templateUrl: './componentes-genericos.component.html',
  styleUrls: ['./componentes-genericos.component.scss'],
  standalone: false
})
export class ComponentesGenericosComponent implements OnInit {

  @Input() entity: 'SOLICITANTE' | 'CLIENTE' | 'DIRECCION' | 'AREA' | 'ESTRUCTURA' | 'SUBCONTRATISTA' | 'TURNO' | 'UNIDAD' = 'SOLICITANTE';
  @Input() title: string = 'Seleccionar';
  @Input() placeholder: string = 'Buscar...';
  @Input() items: any[] = [];
  @Input() initialSearch: string = '';
  @Input() extraData: any = null; // contiene e.g. clienteId para solicitantes/direcciones
  @Input() isMultiSelect: boolean = false;
  @Input() selectedIds: any[] = [];

  searchText: string = '';
  filteredItems: any[] = [];
  localSelectedItems: any[] = [];

  constructor(
    private modalCtrl: ModalController,
    private toastCtrl: ToastController
  ) { }

  ngOnInit() {
    this.searchText = this.initialSearch || '';
    
    // Inicializar elementos seleccionados localmente en base a selectedIds
    if (this.selectedIds && this.selectedIds.length > 0) {
      const normalizedIds = this.selectedIds.map(id => String(id).toLowerCase());
      this.localSelectedItems = this.items.filter(item => 
        normalizedIds.includes(String(item.id).toLowerCase())
      );
    }
    
    this.sortAndFilterItems();
  }

  sortAndFilterItems() {
    const q = this.searchText.trim().toLowerCase();
    
    // Clonamos la lista para no mutar el input original
    let baseItems = [...this.items];

    // Ordenar alfabéticamente por nombre
    baseItems.sort((a, b) => a.nombre.localeCompare(b.nombre));

    if (q) {
      this.filteredItems = baseItems.filter(item => item.nombre.toLowerCase().includes(q));
    } else {
      this.filteredItems = baseItems;
    }
  }

  filterItems(event: any) {
    this.searchText = event.target?.value || '';
    this.sortAndFilterItems();
  }

  selectItem(item: any) {
    if (this.isMultiSelect) {
      this.toggleSelection(item);
    } else {
      this.modalCtrl.dismiss({
        selected: item
      });
    }
  }

  toggleSelection(item: any) {
    const index = this.localSelectedItems.findIndex(i => i.id === item.id);
    if (index > -1) {
      this.localSelectedItems.splice(index, 1);
    } else {
      this.localSelectedItems.push(item);
    }
  }

  isSelected(item: any): boolean {
    return this.localSelectedItems.some(i => i.id === item.id);
  }

  confirmSelection() {
    this.modalCtrl.dismiss({
      selected: this.localSelectedItems
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  doesItemExist(name: string): boolean {
    if (!name) return true;
    return this.items.some(item => item.nombre.toLowerCase().trim() === name.toLowerCase().trim());
  }

  async createNewEntity() {
    // Si requiere clienteId y no existe
    if ((this.entity === 'SOLICITANTE' || this.entity === 'DIRECCION') && !this.extraData?.clienteId) {
      this.showToast('Primero debes seleccionar un cliente', 'warning');
      return;
    }

    let componentProps: any = {
      entity: this.entity,
      autoOpenAdd: true
    };

    if (this.entity === 'CLIENTE') {
      componentProps.initialData = { dt2: this.searchText };
    } else if (this.entity === 'DIRECCION') {
      componentProps.initialData = { 
        dt2: String(this.extraData.clienteId), 
        dt5: this.searchText 
      };
    } else if (this.entity === 'SOLICITANTE') {
      componentProps.initialData = { 
        dt6: String(this.extraData.clienteId), 
        dt2: this.searchText 
      };
    } else if (this.entity === 'SUBCONTRATISTA') {
      componentProps.initialData = { 
        dt2: this.searchText 
      };
    }

    const modal = await this.modalCtrl.create({
      component: AdminCrudPage,
      componentProps: componentProps
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();

    if (data) {
      const newName = data.nombre || data.dt2 || this.searchText;
      const newId = Number(data.id) || 0;
      
      const createdItem = {
        id: newId,
        nombre: newName,
        isNew: true, // banderilla para que el invocador recargue su lista
        data: data
      };

      this.modalCtrl.dismiss({
        selected: createdItem
      });
    }
  }

  async showToast(message: string, color: string = 'danger') {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2500,
      color,
      position: 'bottom'
    });
    await toast.present();
  }
}
